<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Lewa kolumna',
              modelPath: [this, 'form', 'left_column'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Prawa kolumna',
              modelPath: [this, 'form', 'right_column'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
